import React from "react"
import ReactDOM from "react-dom"
import "../src/theme/scss/styles.scss" // < base theme
import App from "./App"

ReactDOM.render(

    <App />,
    document.getElementById("root")
)
